import create from './createAction'

export const SET_START_TIMER = 'SET_START_TIMER'
export const setStartTimer = create(SET_START_TIMER)

export const RESET_TIMER = 'RESET_TIMER'
export const resetTimer = create(RESET_TIMER)

export const SET_SHOW_LOADING_INDICATOR = 'SET_SHOW_LOADING_INDICATOR'
export const setShowLoadingIndicator = create(SET_SHOW_LOADING_INDICATOR)

export const SET_LOADING_INDICATOR_CONTENT = 'SET_LOADING_INDICATOR_CONTENT'
export const setLoadingIndicatorContent = create(SET_LOADING_INDICATOR_CONTENT)

export const GET_SYSTEM_ALERT = 'GET_SYSTEM_ALERT'
export const getSystemAlert = create(GET_SYSTEM_ALERT)
export const SET_SYSTEM_ALERT = 'SET_SYSTEM_ALERT'
export const setSystemAlert = create(SET_SYSTEM_ALERT)
